import Vue from 'vue';
import Prism from 'prismjs';

Prism.languages.insertBefore(
  'javascript',
  'string',
  {
    'md-link': {
      pattern: /\[([^\]]+)]\(([^)]+)\)/,
      greedy: true,
    },
  },
  null
);

// @ts-expect-error: Property 'install' is missing in type /@types/prismjs/index but required in type PluginObject<any>
Vue.use(Prism);
